<template lang="pug">
v-card(outlined).overflow-hidden
  input(
    ref="input"
    type="file"
    name="image"
    :accept="accept"
    style="display:none"
    @change="setImage"
  )
  v-window(v-model="step")
    v-window-item
      v-hover(v-slot="{ hover }")
        v-card(
          height="300"
          outlined
          flat
          @click="$refs.input.click()"
          :class="hover || isDragging ? 'outlined-upload--hover' : ''"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="drop"
        ).ma-2.outlined-upload
          v-card-text.grey.lighten-4.text-center.justify-center.fill-height.d-flex.flex-column
            v-icon.mb-6(
              size="80" :color="hover || isDragging ? 'primary' : ''"
            ) mdi-file-upload-outline
            div(v-if="isDragging")
              strong.primary--text Оставьте файл в этой зоне
            .text-body-1(v-else) Перенесите изображение сюда или кликните для загрузки
    v-window-item.relative
      v-btn.absolute.ma-1(
        v-if="viewClose"
        outlined
        icon color="error"
        @click="close"
      ): v-icon mdi-delete
      cropper(
        ref="cropper"
        style="height:300px"
        :src="selectedImg"
        :resizeImage="{ wheel: false }"
        :stencil-props="{aspectRatio}"
        :default-size="defaultSize"
        :canvas="CANVAS_OPTIONS"
        backgroundClass="grey"
        @change="onChange"
      )
      v-card.absolute-preview.d-flex.flex-column.align-center(
        :class="{'rounded-pill': previewRounded }"
      )
        preview.align-center(
          v-if="selectedImg && preview"
          :width="previewWidth"
          :height="previewWidth / aspectRatio"
          :image="previewData.image"
          :coordinates="previewData.coordinates"
        )
      v-card-actions.pa-0
        slot(v-bind="{ uploadCropped, loading, prev: () => { step = 0; } }")
</template>

<script>
import FileUpload from '@/components/InputFields/FileUpload.vue';

import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

const CANVAS_OPTIONS = {
  minHeight: 0,
  imageSmoothingQuality: 'low',
  imageSmoothingEnabled: false,
  minWidth: 0,
  maxHeight: 512,
  maxWidth: 1024,
};

export default {
  components: { Cropper, Preview, FileUpload },
  props: {
    accept: { type: String, default: 'image/*' },
    value: { type: [Object, String], default: null },
    originalName: { type: String, default: null },
    url: { type: String, default: null },
    aspectRatio: { type: Number, default: null },
    preview: { type: Boolean, default: false },
    previewWidth: { type: Number, default: 200 },
    previewRounded: { type: Boolean, default: false },
    viewClose: { type: Boolean, default: false },
    showSaveButton: { type: Boolean, default: false },
  },
  data() {
    return {
      file: null,
      step: 0,
      selectedImg: null,
      isDragging: false,
      previewData: {
        coordinates: null,
        image: null,
      },
      CANVAS_OPTIONS,
      loading: false,
    };
  },
  created() {
    if (this.url || this.value?.url) {
      this.setImageUrl(this.url || this.value.url);
      this.step = 1;
    }
  },
  methods: {
    defaultSize({ imageSize }) {
      return {
        width: imageSize.width,
        height: imageSize.height,
      };
    },

    onChange({ coordinates, image }) {
      const { canvas } = this.$refs.cropper.getResult();
      const croppedImage = canvas.toDataURL();
      this.previewData = { coordinates, image };
      this.$emit('preview', croppedImage);
    },
    uploadCropped() {
      this.$emit('loading', true);
      this.loading = true;
      const { canvas } = this.$refs.cropper.getResult();
      const croppedImage = canvas.toDataURL();
      fetch(croppedImage).then((res) => res.blob()).then((blob) => {
        const file = new File([blob], 'image.jpg', { type: 'image/jpg', lastModified: Date.now() });
        this.uploadFile(file);
      });
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      this.$rHandler(
        this.$api.system.uploadFiles(formData),
        ({ data }) => {
          const { url, file_name: name } = data.data;
          // this.url = url;
          this.$emit('input', name);
          this.$emit('change', name);
          this.$emit('update:url', url);
          this.$emit('loading', false);
          this.loading = false;
        },
        (e) => {
          console.log('Ошибка в FileUpload', e);
          this.$toasted.error('Не удалось загрузить файл', {
            duration: 2000,
          });
          this.$refs.provider.setErrors(e.response.data.validation.file);
          this.loading = false;
          this.$emit('loading', false);
        },
      );
    },

    setImage(e, isFile) {
      const file = isFile ? e : e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          this.setImageUrl(reader.result);
        };
      } else this.close();
    },
    setImageUrl(url) {
      this.selectedImg = url;
      this.step = 1;
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.input.files = e.dataTransfer.files;
      this.setImage(e.dataTransfer.files[0], true);
      this.isDragging = false;
    },
    close() {
      this.url = null;
      this.step = 0;
      this.$refs.input.value = null;
      this.selectedImg = null;
      this.previewData = {
        coordinates: null,
        image: null,
      };
      this.$emit('input', null);
      this.$emit('change', null);
      this.$emit('update:url', null);
    },
  },
};

</script>
<style scoped>
.outlined-upload {
  border-color: grey !important;
  border-style: dashed !important;
  border-width: 3px !important;
}
.outlined-upload--hover {
  border-color: var(--v-primary-base) !important;
}
.absolute {
  position: absolute;
  z-index: 999;
}
.absolute-preview {
  right: 10px;
  bottom: 10px;
}
.relative {
  position: relative;
}

</style>
